export function handleScroll () {
    const header = document.querySelector('.header');
    const body = document.querySelector('body');

	// get the src of the header logo img
	let logoSrc = header.querySelector('header .logo img').getAttribute('src');
	let logoSrcFixed = '/wp-content/themes/together-2137/assets/src/img/main-tfy-logo-scroll-min.png';

	console.log('logoSrc', logoSrc);

	// does this page have the classname .single-post in the body tag?
	if (body.classList.contains('single-post')) {
		logoSrc = logoSrcFixed;
	}

    function updateHeaderClass () {
        const scrollY = window.scrollY;
        if (scrollY > 80) {
            header.classList.add('fixed-header');
            body.classList.add('fixed-header');
			header.querySelector('.logo img').setAttribute('src', logoSrcFixed);
        } else {
            header.classList.remove('fixed-header');
            body.classList.remove('fixed-header');
			header.querySelector('.logo img').setAttribute('src', logoSrc);
        }
    }

    window.addEventListener('scroll', updateHeaderClass);

    updateHeaderClass();
}
